import { motion, Variants } from "framer-motion";
import { useState } from "react";

type QuestionProps = {
  number: number;
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  variants?: Variants;
};

const Question = ({
  number,
  title,
  children,
  defaultOpen = false,
  variants,
}: QuestionProps) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <motion.div
      variants={variants}
      className={`question-wrapper ${open ? "open" : ""}`}
    >
      <button
        onClick={() => setOpen((prev) => !prev)}
        className={`question-button ${open ? "open" : ""}`}
      >
        <div className="question-title-wrapper">
          <span className="question-number">
            {String(number).padStart(2, "0")}
          </span>
          <span className="question-title">{title}</span>
        </div>

        <motion.div
          animate={{ rotate: open ? 0 : 45 }}
          transition={{ duration: 0.2 }}
          className="question-icon"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </motion.div>
      </button>

      <motion.div
        initial={false}
        animate={{
          height: open ? "auto" : 0,
        }}
        transition={{
          duration: 0.3,
          ease: [0.04, 0.62, 0.23, 0.98],
        }}
        className="question-content"
        style={{ overflow: "hidden" }}
      >
        <motion.div
          className="question-inner"
          initial={false}
          animate={{
            opacity: open ? 1 : 0,
          }}
          transition={{
            duration: 0.2,
          }}
        >
          {children}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Question;
